import { useMemo } from "react";
import _ from "lodash";

import theme from "theme";
import { colors } from "theme/palette";
import { fieldOptionMultipleRetrieve } from "utils/common";

import Box from "components/Box";
import Stack from "components/Stack";
import Tag from "components/Tag";
import Text from "components/Text";

import PrintableFieldTitle from "pages/PrintableChecklist/components/PrintableFieldTitle";

import { EFieldStatus } from "entities/Field/constants";
import { IField } from "entities/Field/sdk";

export interface IPrintableCheckboxField {
  field: IField;
}
const PrintableCheckboxField = ({ field }: IPrintableCheckboxField) => {
  const value = useMemo(
    () =>
      fieldOptionMultipleRetrieve({
        options: field.options,
        value: _.get(field.custom_values, "[0].selected_value"),
      }),
    [field.custom_values, field.options]
  );

  const displayValue = useMemo(() => {
    if (value?.length === 1) {
      return <Box data-testid="field-value">{value[0].label}</Box>;
    }

    return (
      <ul
        style={{
          margin: 0,
        }}
      >
        {value
          ?.map((v) => v.label)
          .map((item) => (
            <li key={item}>
              <Text variant="text2">{item}</Text>
            </li>
          ))}
      </ul>
    );
  }, [value]);

  const valueIsMissing = useMemo(
    () => _.isEmpty(value) || _.isNil(value),
    [value]
  );

  return (
    <Stack
      id={field.field_id.toString()}
      sx={{
        padding: theme.spacing(0.5),
        borderBottom: `1px solid ${colors.blue20}`,
        backgroundColor: "initial",
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="flex-start"
      >
        <PrintableFieldTitle field={field} />
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          justifyContent="flex-end"
          maxWidth="40%"
          paddingTop={0.5}
        >
          {field.status === EFieldStatus.NA ? (
            <Text sx={{ color: colors.gray60 }}>N/A</Text>
          ) : (
            <>
              {valueIsMissing ? (
                <Tag label="missing" variant="red" />
              ) : (
                displayValue
              )}
            </>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
};

export default PrintableCheckboxField;
